var map = {
	"./arrow_down.svg": 405,
	"./campaign.svg": 724,
	"./close.svg": 725,
	"./info.svg": 726,
	"./login_password.svg": 727,
	"./login_user.svg": 728,
	"./power-off.svg": 729,
	"./sort.svg": 730,
	"./surveys.svg": 731,
	"./trash.svg": 732,
	"./upload.svg": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 723;